<!-- Update Modal - Shows when app version is unsupported (non-dismissable) -->
<div class="update-modal-overlay" *ngIf="showModal()">
  <div class="update-modal">
    <div class="update-modal-header">
      <h2 class="update-modal-title">{{ ss.t('update_versionNotSupported') }}</h2>
    </div>

    <div class="update-modal-body">
      <p class="update-modal-message">{{ ss.t('update_mandatoryMessage', { brandName: BRAND_CONFIG.name }) }}</p>
    </div>

    <div class="update-modal-actions">
      <button
        class="btn primary-btn update-btn-force"
        (click)="onForceUpdate()">
        {{ ss.t('update_refreshNow') }}
      </button>
    </div>
  </div>
</div>
